module.exports = __webpack_public_path__ + "static/media/OpenSans Regular-01.bf9c6fc4.svg";